module.exports = __webpack_public_path__ + "img/square_bkgd.609a34ae.png";